import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ArrowLeftOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";

import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigateBackComponent',
  props: {
    backTo: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const router = useRouter();

function goBack() {
  if (props.backTo) {
    router.push(props.backTo);
  } else {
    router.back();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: goBack,
    id: "navigationBack",
    class: "text-blue-900 font-bold text-left flex items-center cursor-pointer space-x-1"
  }, [
    _createVNode(_unref(ArrowLeftOutlined)),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("span", null, _toDisplayString(_ctx.$t("GLOBAL.GO_BACK")), 1)
  ]))
}
}

})